export default "__VITE_ASSET__1f7577b4__"